import Button from "@mui/material/Button";
import { IButtonProperties } from "src/framework/components/buttons";

export interface fullWidthButtonProperties extends IButtonProperties {
  readonly fullWidth?: boolean;

}

const DEFAULT_PARAMENTERS: fullWidthButtonProperties = {
  fullWidth: true,
  onClick: () => { },
};

const FullWidthButton = (
  fullWidthButtonProperties: fullWidthButtonProperties
) => {
  let _parameters: any = {
    ...DEFAULT_PARAMENTERS,
    ...fullWidthButtonProperties,
  };

  return <Button {..._parameters}>{_parameters.text}</Button>;
};

export { FullWidthButton };
